import DefaultElementNodeType from '../DefaultElementNodeType';
import {BUSINESS_SERVICE} from '../../metamodel/Concept';

export default class BusinessServiceNodeType extends DefaultElementNodeType {
	static get typeName() {
		return BUSINESS_SERVICE;
	}
}
